import {Injectable} from '@angular/core';
import {HammerGestureConfig} from '@angular/platform-browser';

/**
 * overrides hammer event properties
 */
@Injectable()
export class CustomHammerConfig extends HammerGestureConfig {
    overrides = {
        'tap': {
            posThreshold: 40,
            interval: 400,
            time: 500
        },
    };
}
